import React from 'react'

export const TableRow = ({ children, onclick = () => {}, style = {}, className = null }) => {
  return (
    <tr onClick={onclick} style={{ style }} className={className}>
      {children}
    </tr>
  )
}
